import React, {Component} from 'react';
import {Button, Input, Tabs, Typography} from "antd";
import Folder from "./Folder";
import ResetPassword from "../layout/ResetPassword";
import {AppContext} from "../libs/ContextLibs";
import {userGetByEmail} from "../requests/User";

const {TabPane} = Tabs;

const {Title} = Typography;

class UserPreferences extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            viewAsUser: null
        };
        this.onOkClick = this.onOkClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onViewChange = this.onViewChange.bind(this);
    }

    onOkClick() {
        this.context.setIsUserNameOverride(true);
        this.context.setUserNameOverride(this.state.viewAsUser);
    }

    onCancelClick() {
        this.context.setIsUserNameOverride(false);
        this.context.setUserNameOverride(null);
        this.setState({viewAsUser: null});

    }

    onViewChange(e) {
        this.setState({viewAsUser: e.target.value});
    }

    componentDidMount() {
        this.setState({viewAsUser: this.context.userNameOverride});
        userGetByEmail(this.context.user.username, (response) => {
            this.setState({user: response.data});
        });
    }

    render() {
        return (
            <div style={{background: '#fff', padding: 24, minHeight: '100%'}}>
                <Title level={4}>User Preferences</Title>
                {this.state.user && this.state.user.role === 'admin' &&
                    <>
                        <br/>
                        <Input.Group compact>
                            <Input value={this.state.viewAsUser} style={{width: 'calc(100% - 200px)'}}
                                   onChange={this.onViewChange} placeholder="View as a user: enter user email"/>
                            <Button type="primary" onClick={this.onOkClick}>OK</Button>
                            <Button type="danger" onClick={this.onCancelClick}>Cancel</Button>
                        </Input.Group>
                        <br/>
                    </>

                }
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Manage Folders" key="1">
                        <Folder/>
                    </TabPane>
                    <TabPane tab="Change Password" key="2">
                        <ResetPassword/>
                    </TabPane>
                </Tabs>

            </div>
        );
    }
}

export default UserPreferences;
